import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypesOrderActionAsync } from '../redux/actions/typeOrderActions'

export const useTypesOrder = () => {
  const { typesOrderState } = useSelector((state: RootState) => state.typeOrder)
  const dispatch = useDispatch()

  const getTypesOrder = () => {
    dispatch(getTypesOrderActionAsync())
  }

  return { typesOrderState, getTypesOrder }
}
